export default __webpack_public_path__ + "static/media/infra-24.4bb5734a.webp";